var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 269,
    viewBox: "0 0 232 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221 1H11C5.47715 1 1 5.47715 1 11V258C1 263.523 5.47715 268 11 268H221C226.523 268 231 263.523 231 258V11C231 5.47715 226.523 1 221 1Z",
    stroke: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 1L39 268",
    stroke: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 195L231 195",
    stroke: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 231L231 231",
    stroke: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78 1L78 268",
    stroke: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 156L231 156",
    stroke: "#D3D3D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117 1L117 268",
    stroke: "#D3D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 117L231 117",
    stroke: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156 1L156 268",
    stroke: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 78L231 78",
    stroke: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195 1L195 268",
    stroke: "#D3D3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39L231 39",
    stroke: "#D3D3D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridMobile);
export default __webpack_public_path__ + "static/media/grid-mobile.0641894b29263b01ac76fda26f7d5e9e.svg";
export { ForwardRef as ReactComponent };